import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';
import { htcmdService } from 'js/services/htcmd.service';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

import * as server from './server';

export const useGetBuyInBonus = ({ translate, bonusCode, getBenefits }) => {
    const formatter = useFormatter();
    const currencyCode = useUserSelector(prop('currencyCode'));
    const dispatch = useDispatch();

    return useCallback(async ({ amount }) => {
        try {
            await server.getBuyInBonus({ currencyCode, amount, bonusCode });
            const bonuses = getBenefits({ value: amount });
            const [bonusPercent, bonusAmount] = bonuses.length > 1 ? bonuses : [null, bonuses[0]];

            if (htcmdService.isEnabled) {
                return;
            }

            const calculatedAmount = amount * (Number(bonusPercent) / 100) + Number(bonusAmount);

            dispatch(showCommonPopupAction({
                content: `${translate('buyInSucessMessage')} ${formatter.formatCurrency(calculatedAmount)}`
            }));
        } catch (e) {
            dispatch(showCommonPopupAction({
                content: translate('error')
            }));
        }
    }, [currencyCode, bonusCode, getBenefits, dispatch, translate, formatter]);
};
